import { render, staticRenderFns } from "./ed-list-substitute-teacher.component.vue?vue&type=template&id=54b537aa&scoped=true&"
import script from "./ed-list-substitute-teacher.component.ts?vue&type=script&lang=ts&"
export * from "./ed-list-substitute-teacher.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-list-substitute-teacher.component.scss?vue&type=style&index=0&id=54b537aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b537aa",
  null
  
)

export default component.exports